import { AppRoutes } from 'config/routes';

// Plan 11 D2: the Documents area's routes (Home · Agreements · Templates,
// and a package's page). Kept here so route-objects only adds one block.
export const DocumentsPaths = {
  // Owner 26 Oct: the Onboarding set's editor and the Send flow.
  Send: 'send',
  Home: '/documents',
  Templates: 'templates',
  Agreements: 'agreements',
  Package: 'packages/:packageId',
  SetEditor: 'templates/sets/onboarding',
};

export const documentsHome = DocumentsPaths.Home;
export const agreementsPath = `${DocumentsPaths.Home}/${DocumentsPaths.Agreements}`;
export const templatesPath = `${DocumentsPaths.Home}/${DocumentsPaths.Templates}`;
export const packagePath = (packageId: number, tab?: string) =>
  `${DocumentsPaths.Home}/packages/${packageId}${tab ? `?tab=${tab}` : ''}`;

export const employeePath = (employeeId: number) =>
  `${AppRoutes.Employees.Home}/${employeeId}`;

export const sendPath = `${DocumentsPaths.Home}/${DocumentsPaths.Send}`;
export const setEditorPath = `${DocumentsPaths.Home}/${DocumentsPaths.SetEditor}`;
// The coordinator's routes (plan 10): a new template, and one template's
// field editor.
export const newTemplatePath = `${templatesPath}/new`;
export const templateEditorPath = (templateId: number, versionId: number) =>
  `${templatesPath}/${templateId}/${versionId}`;
